import { TimetableCard } from '@features/timetables/components/TimetableCard'
import { getTodayDateValue } from '@features/timetables/dateUtils'
import { useStaffTimetable } from '@features/timetables/queries'
import { Box } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

export const Route = createFileRoute('/_layout/staff/$initials/timetable')({
  component: RouteComponent,
})

function RouteComponent() {

    const { initials } = Route.useParams()
    const [censusDate, setCensusDate] = useState(getTodayDateValue)
    const { data: lessons, isLoading, isError } = useStaffTimetable({ initials, censusDate })

    return (
        <Box p="xs" h="100%" mih={0}>
            <TimetableCard
                lessons={lessons}
                loading={isLoading}
                error={isError}
                cardTitle={`Timetable: ${initials}`}
                simpleLessonLabels={{ classCode: true, roomNumber: true }}
                detailedLessonLabels={{ subjectNameAndClassCode: true, roomNumber: true }}
                censusDate={censusDate}
                onCensusDateChange={setCensusDate}
                defaultColorStyle="block"
            />
        </Box>
    )
}
